import React from 'react';
import ReactApexChart from 'react-apexcharts';

const CountData = (props) => {



    return (
        <>
            <span className="summeryTitle">
                {props.summeryTitle}
            </span>
            <div className="col-xs-12 padding-remove">
                <div className="col-xs-3">
                    <div className="countData">{props.countData}</div>
                    <div className="officeTitle">{props.summeryTitle}</div>
                </div>
                <div className="col-xs-9 padding-remove">
                    <div className="col-xs-12 graphSection">
                        <ReactApexChart options={props.options} series={props.series} type={props.graphType}  height='230'/>
                    </div>
                </div>
            </div>
        </>
    );

}
export default CountData;